"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSMMAEditPreOrderDeviceComponent = void 0;
const router_1 = require("@angular/router");
const loader_service_1 = require("../../../services/loader.service");
const orderStatus_service_1 = require("../../../services/orderStatus.service");
const constants = require("../../../util/constants");
const _ = require("underscore");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
class CSMMAEditPreOrderDeviceComponent {
    constructor(orderService, loaderService, modalService, router, route) {
        this.orderService = orderService;
        this.loaderService = loaderService;
        this.modalService = modalService;
        this.router = router;
        this.route = route;
        this.hasTradeIn = false;
        this.showPOCPrice = false;
        this.showEmptySection = false;
        this.showDPPPrice = true;
        this.showNoPOCPrice = false;
        this.showPrepaidPrice = false;
        this.preorderStorageDetailList = [];
        this.colorList = [];
        this.monthlyPaymentSelected = false;
        this.payInFullSelected = false;
        this.pocPriceSelected = false;
        this.currentIndex = 0;
        this.totalEligibleDevices = 0;
        this.viewDetailsExpanded = false;
        this.isVerifiedUser = false;
    }
    ngOnInit() {
        // Listen to the change event on payment method modal
        this.loadingSubscription = this.loaderService.changeEvent.subscribe(() => {
            this.getLoaderStatus();
        });
        this.getUrlParams();
    }
    /**
     * @returns login status of the user
     */
    getLoginStatus() {
        this.loader = true;
        this.orderService.getLoginStatus()
            .subscribe((loginStatus) => {
            this.loader = false;
            this.isLoggedInUser = loginStatus.securityStatus === 4;
            if (this.isLoggedInUser) {
                this.getPreOrderDetails();
            }
            else {
                this.getVerificationStatus();
            }
        });
    }
    getVerificationStatus() {
        this.orderService.getVerificationStatus(this.preorderId).subscribe((status) => {
            if (status) {
                this.isVerifiedUser = true;
                this.getPreOrderDetails();
            }
            else {
                this.router.navigate(['/']);
            }
        });
    }
    getUrlParams() {
        this.loader = true;
        this.preorderId = this.route.snapshot.paramMap.get(constants.preorderIdentifier);
        this.subId = this.route.snapshot.paramMap.get(constants.subIdentifier);
        this.currentDeviceProdId = this.route.snapshot.paramMap.get(constants.productIdentifier);
        this.loader = false;
        if (this.preorderId && this.subId) {
            this.getLoginStatus();
        }
        else {
            this.router.navigate(['/']);
        }
    }
    /**
     * @returns pre order details for MMA user
     */
    getPreOrderDetails() {
        this.loaderService.showLoading();
        this.orderService.getPreOrderDetails(this.preorderId, this.subId).subscribe((preOrderDetails) => {
            if (preOrderDetails) {
                this.getPOCEligibility();
                this.getEligibleDevices();
                this.preorderInfo = preOrderDetails[0];
                if (this.preorderInfo.tradeInItems) {
                    for (const tradeInItems of this.preorderInfo.tradeInItems) {
                        if (tradeInItems.subscriptionId === this.subId) {
                            this.hasTradeIn = true;
                            break;
                        }
                    }
                }
            }
            else {
                this.showEmptySection = true;
            }
            this.loaderService.hideLoading();
        }, () => {
            this.showEmptySection = true;
            this.loaderService.hideLoading();
        });
    }
    getPOCEligibility() {
        this.loaderService.showLoading();
        this.orderService.getPOCSubElibigibility(this.subId).subscribe((pocDetails) => {
            if (pocDetails) {
                this.showPOCPrice = true;
            }
            this.loaderService.hideLoading();
        }, (error) => {
            this.showPOCPrice = false;
            this.loaderService.hideLoading();
        });
    }
    getEligibleDevices() {
        this.loaderService.showLoading();
        this.orderService.getEligiblePreorderDevices(this.subId).subscribe((res) => {
            if (!res || res.length === 0) {
                this.showEmptySection = true;
            }
            else {
                this.eligibleDevices = res;
                this.totalEligibleDevices = (res.length - 1); // since 0 indexing is followed we need to do length - 1
                this.showEmptySection = false;
                this.getAccountType();
            }
            this.loaderService.hideLoading();
        }, () => {
            this.showEmptySection = true;
            this.loaderService.hideLoading();
        });
    }
    getLoaderStatus() {
        this.loader = this.loaderService.isLoading();
    }
    getAccountType() {
        this.loaderService.showLoading();
        this.orderService.getAccountType().subscribe((accountType) => {
            if (accountType) {
                this.accountType = accountType;
                this.setDeviceData();
            }
            else {
                this.showEmptySection = true;
            }
            this.loaderService.hideLoading();
        }, () => {
            this.showEmptySection = true;
            this.loaderService.hideLoading();
        });
    }
    setDeviceData() {
        if (this.accountType === 'BUSINESS') {
            this.showDPPPrice = true;
            this.showPOCPrice = true;
            this.showNoPOCPrice = true;
            this.showPrepaidPrice = false;
        }
        else if (this.accountType === 'POSTPAID') {
            this.showDPPPrice = true;
            this.showNoPOCPrice = true;
            this.showPrepaidPrice = false;
        }
        else if (this.accountType === 'PREPAID') {
            this.showDPPPrice = false;
            this.showPOCPrice = false;
            this.showNoPOCPrice = false;
            this.showPrepaidPrice = true;
        }
        else if ((this.accountType === 'GOVERNMENT')
            || (this.accountType === 'MS_GOV_STATE_AGENCY')
            || (this.accountType === 'MS_GOV_LOCAL_ENTITY')
            || (this.accountType === 'FEDERAL_GOVERNMENT')) {
            this.showDPPPrice = false;
            this.showPOCPrice = true;
            this.showNoPOCPrice = true;
            this.showPrepaidPrice = false;
        }
        // sort storage based on storage size
        for (let i = 0; i < this.eligibleDevices.length; i++) {
            this.eligibleDevices[i].preorderStorageDetailList = _.sortBy(this.eligibleDevices[i].preorderStorageDetailList, 'storageSize');
        }
        // setting the default device details
        this.setDeviceOptions();
    }
    getProduct(prodId) {
        this.loaderService.showLoading();
        this.viewDetailsExpanded = false;
        this.orderService.getProductDetails(prodId).subscribe((data) => {
            if (data) {
                this.deviceEdit = data.product;
                this.checkTermLengthEligibility(prodId);
                // for wearable device NOPOC and DPP
                if (this.deviceEdit.formFactorCode === 6) {
                    this.showNoPOCPrice = true;
                    this.showPOCPrice = false;
                }
            }
            else {
                this.showEmptySection = true;
            }
            this.loaderService.hideLoading();
        }, (error) => {
            this.error = error;
            this.loaderService.hideLoading();
        });
    }
    checkTermLengthEligibility(prodIds) {
        this.loaderService.showLoading();
        this.orderService.checkDPPTermEligibility(prodIds).subscribe((dppEligibilityTerms) => {
            var _a, _b;
            if ((dppEligibilityTerms === null || dppEligibilityTerms === void 0 ? void 0 : dppEligibilityTerms.dppEligibility) && ((_a = dppEligibilityTerms === null || dppEligibilityTerms === void 0 ? void 0 : dppEligibilityTerms.eligibleTermList) === null || _a === void 0 ? void 0 : _a.length) > 0 && ((_b = this.deviceEdit.pricedItem.termDetailsList) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                const eligibleTermDetails = [];
                // Loop over old term list and add only the eligible terms
                for (const eligibleTerm of dppEligibilityTerms.eligibleTermList) {
                    for (const availableTerm of this.deviceEdit.pricedItem.termDetailsList) {
                        // If available term matches eligible term, add it
                        if (parseInt(availableTerm.termLength, 10) === eligibleTerm) {
                            eligibleTermDetails.push(availableTerm);
                            break;
                        }
                    }
                }
                if (eligibleTermDetails != null && eligibleTermDetails.length !== 0) {
                    // Sort the array
                    eligibleTermDetails.sort((a, b) => a.termId > b.termId ? -1 : 1);
                    this.selectedMonthlyPrice = eligibleTermDetails[0].monthlyInstallment;
                    this.setDPPPrice(eligibleTermDetails[0]);
                }
                else {
                    this.setDefaultPrice();
                }
                this.deviceEdit.pricedItem.termDetailsList = eligibleTermDetails;
            }
            else {
                this.deviceEdit.pricedItem.termDetailsList = [];
                this.setDefaultPrice();
            }
            this.loaderService.hideLoading();
        }, () => {
            this.deviceEdit.pricedItem.termDetailsList = [];
            this.setDefaultPrice();
            this.loaderService.hideLoading();
        });
    }
    setDefaultPrice() {
        if (this.showNoPOCPrice || this.showPrepaidPrice) {
            this.setFullPrice();
        }
        else if (this.showPOCPrice) {
            this.setPOCPrice();
        }
    }
    setDPPPrice(termDetail) {
        this.selectedTermDetails = termDetail;
        this.selectedMonthlyPrice = termDetail.monthlyInstallment;
        this.selectedTerm = termDetail.termLength;
        this.monthlyPaymentSelected = true;
        this.payInFullSelected = false;
        this.pocPriceSelected = false;
    }
    setFullPrice() {
        this.monthlyPaymentSelected = false;
        this.payInFullSelected = true;
        this.pocPriceSelected = false;
    }
    setPOCPrice() {
        this.monthlyPaymentSelected = false;
        this.payInFullSelected = false;
        this.pocPriceSelected = true;
    }
    changeStorageOption(storageSize, index) {
        this.selectedStorage = storageSize;
        if (this.eligibleDevices[this.currentIndex].preorderStorageDetailList[index].storageSize === storageSize) {
            this.colorList = this.eligibleDevices[this.currentIndex].preorderStorageDetailList[index].preorderColorDetailList;
        }
        this.selectedDeviceProdId = this.colorList[0].deviceProdId;
        if (this.selectedDeviceProdId) {
            this.selectedColor = this.colorList[0].colorName;
            this.getProduct(this.selectedDeviceProdId);
        }
    }
    changeColorOption(selectedColor) {
        this.selectedColor = selectedColor.colorName;
        this.selectedDeviceProdId = selectedColor.deviceProdId;
        if (this.selectedDeviceProdId) {
            this.getProduct(this.selectedDeviceProdId);
        }
    }
    setDeviceOptions() {
        // setting the default device properties
        this.preorderStorageDetailList = this.eligibleDevices[this.currentIndex].preorderStorageDetailList;
        this.colorList = this.eligibleDevices[this.currentIndex].preorderStorageDetailList[0].preorderColorDetailList;
        this.selectedDeviceProdId = this.eligibleDevices[this.currentIndex].preorderStorageDetailList[0].preorderColorDetailList[0].deviceProdId;
        this.selectedStorage = this.eligibleDevices[this.currentIndex].preorderStorageDetailList[0].storageSize;
        this.selectedColor = this.colorList[0].colorName;
        this.getProduct(this.selectedDeviceProdId);
    }
    setNextDeviceDetails() {
        if (this.currentIndex < (this.eligibleDevices.length - 1)) {
            this.currentIndex += 1;
            this.setDeviceOptions();
        }
    }
    setPrevDeviceDetails() {
        if (this.currentIndex > 0) {
            this.currentIndex -= 1;
            this.setDeviceOptions();
        }
    }
    showHideDetails() {
        this.viewDetailsExpanded = !this.viewDetailsExpanded;
    }
    replacePreorderDetails() {
        this.loaderService.showLoading();
        const replaceContent = {
            preorderId: this.preorderId,
            deviceId: this.selectedDeviceProdId,
            subId: this.subId,
            isDPP: this.monthlyPaymentSelected,
            isPOC: this.pocPriceSelected,
            curDeviceId: this.currentDeviceProdId,
            hasTradeIn: this.hasTradeIn,
            isPreOrder: true,
            deviceTermId: this.monthlyPaymentSelected ? this.selectedTermDetails.termId : null,
            deviceTermLength: this.monthlyPaymentSelected ? parseInt(this.selectedTermDetails.termLength, 10) : null,
            monthlyInstallment: this.monthlyPaymentSelected ? this.selectedMonthlyPrice : null
        };
        this.orderService.replaceDevice(replaceContent).subscribe((response) => {
            if (response === null || response === void 0 ? void 0 : response.success) {
                window.location.href = constants.cartUrl;
            }
            this.loaderService.hideLoading();
        }, (error) => {
            this.error = error;
            this.loaderService.hideLoading();
        });
    }
    ngOnDestroy() {
        this.loadingSubscription.unsubscribe();
    }
}
exports.CSMMAEditPreOrderDeviceComponent = CSMMAEditPreOrderDeviceComponent;
//# sourceMappingURL=edit-preorder-device.component.js.map